import request from './request'

/**
 * 日程管理API
 */
export const scheduleApi = {
  /**
   * 获取日程列表
   * @param {Object} params - 查询参数
   * @param {number} [params.status] - 状态筛选
   * @param {string} [params.type] - 类型筛选
   * @param {string} [params.startTime] - 开始时间
   * @param {string} [params.endTime] - 结束时间
   * @param {number} [params.pageNum] - 页码
   * @param {number} [params.pageSize] - 每页大小
   */
  getList(params) {
    return request({
      url: '/schedules',
      method: 'get',
      params
    })
  },

  /**
   * 获取所有日程（按日期范围，自己创建的 + 他人创建的我是参与人的）
   * @param {Object} params - 查询参数
   * @param {string} params.startTime - 开始时间 (ISO 8601格式)
   * @param {string} params.endTime - 结束时间 (ISO 8601格式)
   */
  getAllByDateRange(params) {
    return request({
      url: '/schedules/all/by-date-range',
      method: 'get',
      params
    })
  },

  /**
   * 获取今日所有日程（自己创建的 + 他人创建的我是参与人的）
   */
  getToday() {
    return request({
      url: '/schedules/all/today',
      method: 'get'
    })
  },

  /**
   * 获取进行中日程数量
   */
  getCount() {
    return request({
      url: '/schedules/count',
      method: 'get'
    })
  },

  /**
   * 获取日程详情
   * @param {number} id - 日程ID
   */
  getDetail(id) {
    return request({
      url: `/schedules/${id}`,
      method: 'get'
    })
  },

  /**
   * 创建日程
   * @param {Object} data - 日程数据
   */
  create(data) {
    return request({
      url: '/schedules',
      method: 'post',
      data
    })
  },

  /**
   * 更新日程
   * @param {number} id - 日程ID
   * @param {Object} data - 日程数据
   */
  update(id, data) {
    return request({
      url: `/schedules/${id}`,
      method: 'put',
      data
    })
  },

  /**
   * 删除日程
   * @param {number} id - 日程ID
   */
  delete(id) {
    return request({
      url: `/schedules/${id}`,
      method: 'delete'
    })
  },

  /**
   * 完成日程
   * @param {number} id - 日程ID
   */
  complete(id) {
    return request({
      url: `/schedules/${id}/complete`,
      method: 'put'
    })
  },

  /**
   * 取消日程
   * @param {number} id - 日程ID
   */
  cancel(id) {
    return request({
      url: `/schedules/${id}/cancel`,
      method: 'put'
    })
  },

  /**
   * 获取参与人列表
   * @param {number} id - 日程ID
   */
  getAttendees(id) {
    return request({
      url: `/schedules/${id}/attendees`,
      method: 'get'
    })
  },

  /**
   * 添加参与人
   * @param {number} id - 日程ID
   * @param {Object} data - 添加参与人数据
   */
  addAttendees(id, data) {
    return request({
      url: `/schedules/${id}/attendees`,
      method: 'post',
      data
    })
  },

  /**
   * 移除参与人
   * @param {number} eventId - 日程ID
   * @param {number} userId - 用户ID
   */
  removeAttendee(eventId, userId) {
    return request({
      url: `/schedules/${eventId}/attendees/${userId}`,
      method: 'delete'
    })
  },

  /**
   * 响应参与邀请
   * @param {number} eventId - 日程ID
   * @param {number} status - 响应状态: 2-接受 3-拒绝
   */
  responseInvite(eventId, status) {
    return request({
      url: `/schedules/${eventId}/attendees/response`,
      method: 'put',
      params: { status }
    })
  },

  /**
   * 检测时间冲突
   * @param {Object} params - 检测参数
   */
  checkConflict(params) {
    return request({
      url: '/schedules/check-conflict',
      method: 'post',
      params
    })
  }
}

export default scheduleApi
